module.exports = __webpack_public_path__ + "static/media/offroad.56ccd50e.svg";